import React from "react";
import cx from "classnames";

import styles from "./simple-list.module.scss";
import { TitleBar } from "../TitleBar/TitleBar";
import { IterationItem } from "../IterationItem/IterationItem";

const ListContext = React.createContext<{
  size?: SimpleList.Props["size"];
}>({});

export namespace SimpleList {
  export type Props = {
    className?: string;
    title?: JSX.Element | string;
    size?: "small" | "medium";
    parent?: (event: React.MouseEvent) => void;
  };
}

export namespace Li {
  export type Props = React.HTMLAttributes<HTMLLIElement> & {
    hasChildren?: boolean;
    onClick?: () => void;
  };
}

export const SimpleList = ({
  className,
  size = "medium",
  title,
  parent,
  ...props
}: React.PropsWithChildren<SimpleList.Props>): JSX.Element => (
  <ListContext.Provider value={{ size }}>
    {title && (
      <TitleBar parent={parent} size={size}>
        {title}
      </TitleBar>
    )}
    <ul className={cx(styles.simpleList, className)} {...props} />
  </ListContext.Provider>
);

export const Li = ({ className, onClick, ...props }: Li.Props): JSX.Element => {
  const { size } = React.useContext(ListContext);

  return (
    <IterationItem
      {...props}
      as="li"
      className={cx(className, onClick && styles.simpleListLiClickable)}
      onClick={onClick}
      size={size}
    />
  );
};
